<ngx-loading-bar [color]="'#00a859'"></ngx-loading-bar>

<!-- Top Navigation Bar -->
<header class="top-navbar">
  <div class="navbar-content">
    <button *ngIf="showBackButton" class="nav-action-btn back-button" (click)="goBack()">
      <i class="fa fa-chevron-left"></i>
    </button>

    <div class="navbar-logo">
      <i class="fa fa-utensils logo-icon"></i>
      <span class="logo-text">HMS Waiter</span>
    </div>

    <div class="navbar-actions">
      <button class="nav-action-btn refresh-button" (click)="refreshPage()">
        <i class="fa fa-sync-alt"></i>
      </button>

      <!-- Notification indicator in top bar -->
      <div class="top-notification-indicator" *ngIf="notificationCount > 0">
        <div class="notification-pulse">
          <span class="notification-count">{{ notificationCount }}</span>
        </div>
      </div>
    </div>
  </div>
</header>

<!-- Page Content -->
<div class="app-content">
  <router-outlet></router-outlet>
</div>

<!-- Bottom Navigation Bar -->
<nav class="bottom-navbar">
  <div class="navbar-blur"></div>
  <ul class="nav-list">
    <li class="nav-item">
      <a routerLink="/home" routerLinkActive="active" class="nav-link">
        <div class="nav-icon-wrapper">
          <i class="fa fa-home nav-icon"></i>
          <div class="nav-ripple"></div>
        </div>
        <span class="nav-label">Home</span>
      </a>
    </li>

    <li class="nav-item">
      <a routerLink="/transactions" routerLinkActive="active" class="nav-link">
        <div class="nav-icon-wrapper">
          <i class="fa fa-credit-card nav-icon"></i>
          <div class="nav-ripple"></div>
        </div>
        <span class="nav-label">Transactions</span>
      </a>
    </li>

    <li class="nav-item">
      <a [routerLink]="['/notifications']" routerLinkActive="active" class="nav-link">
        <div class="nav-icon-wrapper">
          <i class="fa fa-bell nav-icon"></i>
          <div class="nav-ripple"></div>
          <span *ngIf="notificationCount > 0" class="notification-badge">
            {{ notificationCount > 99 ? '99+' : notificationCount }}
          </span>
        </div>
        <span class="nav-label">Notifications</span>
      </a>
    </li>

    <li class="nav-item">
      <a routerLink="/profile" routerLinkActive="active" class="nav-link">
        <div class="nav-icon-wrapper profile-wrapper">
          <div class="profile-image-container">
            <img *ngIf="userDet?.user?.image; else defaultIcon"
                 [src]="userDet.user.image"
                 class="profile-image"
                 alt="User Profile">
            <ng-template #defaultIcon>
              <i class="fa fa-user nav-icon"></i>
            </ng-template>
          </div>
          <div class="nav-ripple"></div>
        </div>
        <span class="nav-label">Profile</span>
      </a>
    </li>
  </ul>
</nav>
